import { ReplayOutlined } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import { useState } from 'react';
import { FailureKind } from '@/hooks/api/assets/useGetRecentFailures';
import { BatchRemediationDialog } from './BatchRemediationDialog';
import { RecreateReportLink } from './RecreateReportLink';
import { isRemediableKind, REMEDIATION_COPY } from './remediationCopy';
import { useCanRemediate } from './useCanRemediate';

export const BatchRemediationButton = ({ kind }: { kind: FailureKind }) => {
  const canRemediate = useCanRemediate(kind);
  const [isOpen, setIsOpen] = useState(false);

  if (!canRemediate) return <span />;

  if (!isRemediableKind(kind)) {
    return <RecreateReportLink label='Create failed reports again from Reports' testId={`batch-remediation-${kind}`} />;
  }

  const copy = REMEDIATION_COPY[kind];
  const label = `${copy.verbImperative} failed ${copy.itemPlural}`;

  return (
    <>
      <Tooltip title={label}>
        <IconButton
          size='small'
          color='secondary'
          onClick={() => setIsOpen(true)}
          aria-label={label}
          data-testid={`batch-remediation-${kind}`}
        >
          <ReplayOutlined fontSize='small' />
        </IconButton>
      </Tooltip>
      {isOpen && <BatchRemediationDialog kind={kind} onClose={() => setIsOpen(false)} />}
    </>
  );
};
